module.exports = __webpack_public_path__ + "static/img/mpi.4f2ef32a.png";